import { render, staticRenderFns } from "./DepositHeader.vue?vue&type=template&id=5de7d695&scoped=true"
import script from "./DepositHeader.vue?vue&type=script&lang=ts"
export * from "./DepositHeader.vue?vue&type=script&lang=ts"
import style0 from "./DepositHeader.vue?vue&type=style&index=0&id=5de7d695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7d695",
  null
  
)

export default component.exports